import { createReducer } from '@reduxjs/toolkit';
import { benchmarkActions } from '~/behaviors/actions/benchmark.actions';

const replaceList = (state, action) => {
  return action.payload;
};

const availableList = createReducer([], (builder) => {
  builder.addCase(benchmarkActions.fetchAvailableBenchmarkList.fulfilled, replaceList);
});

export { availableList };
